import { makeAutoObservable, runInAction } from 'mobx';
import {
  IGeneratRentPaymentList,
  IGetRentHistoryParam,
  IRentAdvancePayment,
  IRentPayment,
  IRentPaymentDelete,
  IRentPaymentDetailsParam,
  IRentPaymentParams,
  IRentPaymentReport,
  RentReportData,
} from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import agent from 'src/api/agent';
export default class RentPaymentStore {
  openDialog = false;

  openCreateDialog = false;

  openDeleteDialog = false;

  openDetailsDialog = false;

  openGeneratRentListDialog = false;

  RentPaymentList: IRentPayment[] = [];

  RentPaymentRegistry = new Map<number, IRentPayment>();

  editMode = false; //When click on edit button

  selectedRentPayment: IRentPayment | undefined = undefined;

  selectedRentPaymentDetail: IRentPayment | undefined = undefined;

  RentpaymentReportResult: RentReportData | undefined;

  RentPaymentHistoryResult: IRentPayment[] | undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  //Pagination
  loadRentPayment = async (params: IRentPaymentParams) => {
    // this.RentPaymentRegistry.clear();

    const result = await agent.RentPayment.getList(params);
    console.log(result.data);
    runInAction(() => {
      this.RentPaymentList = result.data;
    });
  };

  clearSelectedRentPayment = () => {
    this.editMode = false;
    this.selectedRentPayment = undefined;
  };

  deleteRentPayment = async (param: IRentPaymentDelete) => {
    console.log(param);
    await agent.RentPayment.delete(param);
    runInAction(() => {
      this.setOpenCloseDeleteDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  setOpenCloseCreateDialog = () => (this.openCreateDialog = !this.openCreateDialog);

  setOpenCloseDeleteDialog = () => (this.openDeleteDialog = !this.openDeleteDialog);

  setOpenCloseDetailsDialog = () => (this.openDetailsDialog = !this.openDetailsDialog);

  setOpenCloseGeneratRentListDialog = () =>
    (this.openGeneratRentListDialog = !this.openGeneratRentListDialog);

  createRentPayment = async (RentPayment: IRentAdvancePayment) => {
    console.log(RentPayment);
    await agent.RentPayment.create(RentPayment, RentPayment.attachment);
    runInAction(() => {});
  };

  GeneratRentPaymentList = async (RentPayment: IGeneratRentPaymentList) => {
    await agent.RentPayment.GenerateRentPaymentList(RentPayment);
    runInAction(() => {
      // this.loadRentPayment({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedRentPayment();
    });
  };

  updateRentPayment = async (RentPayment: IRentPayment) => {
    await agent.RentPayment.update(RentPayment, RentPayment.attachment);

    runInAction(() => {
      this.loadRentPayment({ years: RentPayment.year, months: RentPayment.month });
      // this.RentPaymentRegistry.delete(RentPayment.rentPaymentId!);
      // this.RentPaymentRegistry.set(RentPayment.rentPaymentId!, RentPayment);
      this.clearSelectedRentPayment();
    });
  };

  loadRentPaymentDetail = async (param: IRentPaymentDetailsParam) => {
    const getRenPaymentDetail = await agent.RentPayment.getDetail(param);
    runInAction(() => {
      this.selectedRentPaymentDetail = getRenPaymentDetail;
    });
  };

  loadRentPaymentReport = async (reportParams: IRentPaymentReport) => {
    // console.log(reportParams);
    const axiosResponse = await agent.RentPayment.getRentPaymentReport(reportParams);

    runInAction(() => {
      this.RentpaymentReportResult = axiosResponse.data;
    });
  };

  loadRentPaymentDailyReport = async (reportParams: IRentPaymentReport) => {
    // console.log(reportParams);
    const axiosResponse = await agent.RentPayment.getRentPaymentDailyReport(reportParams);

    runInAction(() => {
      this.RentpaymentReportResult = axiosResponse.data;
    });
  };

  GetRentPaymentHistory = async (reportParams: IGetRentHistoryParam) => {
    const axiosResponse = await agent.RentPayment.GetHistory(reportParams);

    runInAction(() => {
      this.RentPaymentHistoryResult = axiosResponse.data;
    });
  };
}
